import * as React from 'react'
import { IServiceEditStep, IServiceEditStepData } from '../../../types/index'

interface IServiceCreateHeaderProps {
  steps: IServiceEditStep[]
  currentStep: IServiceEditStepData
  currentError: { isError: boolean; message: string }
}

const ServiceCreateHeader = (props: IServiceCreateHeaderProps) => {
  return (
    <div>
      <div>
        {props.currentError.message.length > 0 && (
          <div className={'pr1 pl3 pt1 pb1 font-white ' + (props.currentError.isError ? 'bg-red' : 'bg-green')}>
            {props.currentError.message}
          </div>
        )}
        <div className='col-12 flex flex-row pl2 pt3 pb3 items-baseline'>
          <div className='font-blue-grey h2 bold'>Create New Service</div>
          {props.steps && props.currentStep && (
            <div className='h5 font-grey2 ml2'>
              Step {props.currentStep.position + 1} of {props.steps.length}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ServiceCreateHeader



// WEBPACK FOOTER //
// ./src/components/services/edit/ServiceCreateHeader.tsx